import './App.css';
import SearchAppBar from './SearchAppBar.js';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Outlet } from "react-router-dom";

const theme = createTheme({
  palette: {
    primary: {
      main: '#141d3b',
    },
  },
});

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <SearchAppBar />
        <Outlet />
      </ThemeProvider>
    </div>
  );
}

export default App;
